import { GameSession } from "../../GameSession";
export class PickBonusSession extends GameSession
{
	
	//public state: PickBonusState = PickBonusState.Idle;
	public currentPage:number = 0;
	public win: number = 0;
	public left: number = 0;
	public totalWin: number = 0 ;

	constructor() {
		super();
	}

	public static FromValues(currentPage:number, win:number, left: number, totalWin:number): PickBonusSession {
		
		let ps = new PickBonusSession();

		//ps.state = state;
		ps.currentPage = currentPage;
		ps.win = win;
		ps.left = left;
		ps.totalWin = totalWin;
		return ps;
	}

	public Update(other: PickBonusSession): void
	{
		//this.state = other.state;
		this.currentPage = other.currentPage;
		this.win = other.win;
		this.left = other.left;
		this.totalWin = other.totalWin;
	}

	public Reset(): void
	{
		this.left = 0;
		this.totalWin = 0 ;
		this.win = 0;
		this.currentPage = 0;
	}


}